(function(){
     'use strict';

     angular
        .module('appback')
        .factory('CalendariogastoService', CalendariogastoService);

    CalendariogastoService.$inject = ['$http'];

    function CalendariogastoService($http){


        var service= {
           guardarCalendariogasto:guardarCalendariogasto,
           eliminarGasto:eliminarGasto,
           revisarCierre:revisarCierre,
           cerrarMes:cerrarMes,
           analizarFoto:analizarFoto
        };

        return service;
 		function guardarCalendariogasto(datos,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
               datos:datos
            });
            $http.post('/backend/calendariogastos/guardargasto', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                return false;
            }
        }

        function eliminarGasto(id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
               id:id
            });
            $http.post('/backend/calendariogastos/eliminargasto', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                return false;
            }
        }

        function revisarCierre(fecha,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
               fecha:fecha
            });
            $http.post('/backend/calendariogastos/revisarcierre', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                return false;
            }
        }

        function cerrarMes(fecha,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
               fecha:fecha
            });
            $http.post('/backend/calendariogastos/cerrarmes', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                return false;
            }
        }

        function analizarFoto(image, callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
               image:image
            });
            $http.post('/backend/calendariogastos/analizarfoto', data, config)
            .success(function(response){
                callback(response);
            })
            .error(function(){
                callback({success: false, message: "Error al comunicarse con el servidor."});
            });
        }
    }
})();